import { SET_IS_DISABLED_EDITION } from '../actionTypes';
import { actions } from '../reducer';

export default (value) => actions[SET_IS_DISABLED_EDITION](value);
